/* 水印配置 */
let watermark = {};

let setWatermark = (str, fontSize = 16, opacity = 0.15, angle = -20, color = '#000000') => {
    let id = 'watermark_' + Math.random().toString(36).substr(2, 9);

    // 移除旧水印
    const oldWatermark = document.getElementById('watermark_id');
    if (oldWatermark) {
        document.body.removeChild(oldWatermark);
    }

    // 创建画布
    let canvas = document.createElement('canvas');
    // 获取设备像素比，解决高DPI设备模糊问题
    const ratio = window.devicePixelRatio || 1;

    // 设置canvas大小
    const canvasWidth = 200;
    const canvasHeight = 200;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    // 保持CSS宽高不变
    canvas.style.width = canvasWidth + 100 + 'px';
    canvas.style.height = canvasHeight + 100 + 'px';

    let ctx = canvas.getContext('2d');
    // 缩放绘制上下文以适配设备像素比
    ctx.scale(ratio, ratio);

    // 设置水印样式
    ctx.rotate(angle * Math.PI / 180);
    ctx.font = `${fontSize}px Vedana`;
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.globalAlpha = opacity;

    // 绘制水印文本（支持多行数组）
    const lines = Array.isArray(str) ? str : [str];
    const lineHeight = fontSize * 1.5;
    const startY = canvasHeight / 2 - (lines.length - 1) * lineHeight / 2;

    lines.forEach((text, index) => {
        ctx.fillText(text, canvasWidth / 2, startY + index * lineHeight);
    });

    // 创建水印容器
    let div = document.createElement('div');
    div.id = 'watermark_id';
    div.style.pointerEvents = 'none';
    div.style.position = 'fixed';
    div.style.top = '-30px';
    div.style.left = '-100px';
    div.style.bottom = '0';
    div.style.right = '0';
    div.style.opacity = '0.5';
    div.style.zIndex = '100000';
    div.style.background = 'url(' + canvas.toDataURL('image/png') + ') left top repeat';
    // 关键：设置背景大小与Canvas的CSS大小一致
    div.style.backgroundSize = `${canvasWidth}px ${canvasHeight}px`;
    document.body.appendChild(div);

    return id;
}

// 防篡改监听（可选）
const observeWatermark = () => {
    const targetNode = document.getElementById('watermark_id');
    if (!targetNode) return;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            // 检查水印属性是否被修改或元素被移除
            if (mutation.target === targetNode ||
                Array.from(mutation.removedNodes).includes(targetNode)) {
                console.warn('请勿修改或删除水印，你的操作已被记录。');
                // 重新生成水印
                setWatermark(watermark.currentConfig.str,
                    watermark.currentConfig.fontSize,
                    watermark.currentConfig.opacity,
                    watermark.currentConfig.angle,
                    watermark.currentConfig.color);
            }
        });
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true
    });
};

// 设置水印（对外暴露的方法）
watermark.set = (str, fontSize = 16, opacity = 0.1, angle = -20, color = '#000000') => {
    // 存储当前配置，用于防篡改后重新生成
    watermark.currentConfig = { str, fontSize, opacity, angle, color };

    let id = setWatermark(str, fontSize, opacity, angle, color);

    // 监听窗口变化和滚动（确保水印始终覆盖全屏）
    const resizeObserver = new ResizeObserver(() => {
        setWatermark(str, fontSize, opacity, angle, color);
    });

    resizeObserver.observe(document.body);

    // 传统resize监听作为备用
    window.onresize = () => {
        setWatermark(str, fontSize, opacity, angle, color);
    };

    // 启动防篡改监听（根据需要启用）
    // observeWatermark();
}

// 移除水印（可选）
watermark.remove = () => {
    const watermarkElement = document.getElementById('watermark_id');
    if (watermarkElement) {
        document.body.removeChild(watermarkElement);
    }
}

export default watermark;